export const SET_ENTRY_POINT = 'SET_ENTRY_POINT';
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
export const SET_PAYMENT_METHOD_STEP = 'SET_PAYMENT_METHOD_STEP';
export const UPDATE_SEPA_MANDATE = 'UPDATE_SEPA_MANDATE';
export const RESET_PAYMENT_METHOD = 'RESET_PAYMENT_METHOD';

export const CHECK_SEPA_BIC_REQUEST = 'CHECK_SEPA_BIC_REQUEST';
export const CHECK_SEPA_BIC_SUCCESS = 'CHECK_SEPA_BIC_SUCCESS';
export const CHECK_SEPA_BIC_FAILURE = 'CHECK_SEPA_BIC_FAILURE';

export const CHECK_SEPA_IBAN_REQUEST = 'CHECK_SEPA_IBAN_REQUEST';
export const CHECK_SEPA_IBAN_SUCCESS = 'CHECK_SEPA_IBAN_SUCCESS';
export const CHECK_SEPA_IBAN_FAILURE = 'CHECK_SEPA_IBAN_FAILURE';

export const CHECK_SEPA_ZIP_REQUEST = 'CHECK_SEPA_ZIP_REQUEST';
export const CHECK_SEPA_ZIP_SUCCESS = 'CHECK_SEPA_ZIP_SUCCESS';
export const CHECK_SEPA_ZIP_FAILURE = 'CHECK_SEPA_ZIP_FAILURE';

export const SUBMIT_SEPA_MANDATE_REQUEST = 'SUBMIT_SEPA_MANDATE_REQUEST';
export const SUBMIT_SEPA_MANDATE_SUCCESS = 'SUBMIT_SEPA_MANDATE_SUCCESS';
export const SUBMIT_SEPA_MANDATE_FAILURE = 'SUBMIT_SEPA_MANDATE_FAILURE';

export const UPDATE_SEPA_BRANCH_ASSIGNMENT = 'UPDATE_SEPA_BRANCH_ASSIGNMENT';
export const UPDATE_SEPA_ALL_BRANCHES_ASSIGNMENT =
  'UPDATE_SEPA_ALL_BRANCHES_ASSIGNMENT';

export const SUBMIT_SEPA_BRANCH_ASSIGNMENT_REQUEST =
  'SUBMIT_SEPA_BRANCH_ASSIGNMENT_REQUEST';
export const SUBMIT_SEPA_BRANCH_ASSIGNMENT_SUCCESS =
  'SUBMIT_SEPA_BRANCH_ASSIGNMENT_SUCCESS';
export const SUBMIT_SEPA_BRANCH_ASSIGNMENT_FAILURE =
  'SUBMIT_SEPA_BRANCH_ASSIGNMENT_FAILURE';
